import { Box, Paper, Stack, Typography, Button } from "@mui/material";
import { useQuizContext, useEventContext } from "contexts";
import { useNavigate } from "react-router-dom";
import { Question } from "types";
import { NavUtils, NavPages } from "utils";

interface Props {
    correctlyAnsweredQuestions: Question[];
    incorrectlyAnsweredQuestions: Question[];
}

export const SinglePlayerResultScreen = (props: Props) => {
        const { quiz } = useQuizContext();
    const event = useEventContext();
    const navigate = useNavigate();

    const getAnsweredPercentage = () => {
        return (100 * props.correctlyAnsweredQuestions.length / (props.correctlyAnsweredQuestions.length + props.incorrectlyAnsweredQuestions.length)).toFixed(2);
    };

    const onQuizListClick = () => {
        navigate(NavUtils.generateNavPath(NavPages.QuizSelector, undefined, event?.alias))
    }
    

    return (
        <Box className="end-screen-wrapper">
            <Paper variant="elevation" elevation={3}>
                <Stack className="end-screen-stack" direction="column" spacing={2}>
                    <h2 className="quiz-title">{quiz.name}</h2>
                    <Stack direction="row" spacing={2} className="question-score" padding="0 30px">
                        <Typography variant="body1">Total correctly answered questions:</Typography>
                        <Typography variant="body1">{props.correctlyAnsweredQuestions.length}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} justifyContent="space-between" padding="0 30px">
                        <Typography variant="body1">Total incorrectly answered questions:</Typography>
                        <Typography variant="body1">{props.incorrectlyAnsweredQuestions.length}</Typography>
                    </Stack>
                    <Stack direction="row" spacing={2} justifyContent="space-between" padding="0 30px">
                        <Typography variant="h4">Correct Percentage:</Typography>
                        <Typography variant="h4">{getAnsweredPercentage()}%</Typography>
                    </Stack>
                    <Button onClick={onQuizListClick}> Back to Quiz List</Button>
                </Stack>
            </Paper>
        </Box>
    );
};